





export const worksheetBuilderHeading = "Create a worksheet in seconds";

export const worksheetBuilderSubtitle =
"Turn any topic or content into ready-to-use questions";

export const topicPastePlaceholder =
  "Paste content or enter a topic for your worksheet";

export const uploadContentLabel = "UPLOAD CONTENT (PDF, DOC, TXT)";

export const uploadAcceptTypes = ".pdf,.doc,.docx,.txt";

export const uploadFileUploadedLabel = "File Uploaded";

export const uploadReuploadLabel = "Reupload the file";

export const uploadPreviewLabel = "Preview";

export const previewDocumentContent = [
"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
"Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."];


export {
  familiarTopics,
  familiarTopicsHeading,
} from "../shared/familiarTopics";

export const questionTypes = [
{ id: "mcqs", label: "MCQS" },
{ id: "short-answer", label: "SHORT ANSWER" },
{ id: "true-false", label: "TRUE / FALSE" },
{ id: "matching", label: "MATCHING" },
{ id: "fill-blanks", label: "FILL IN BLANKS" }];


export const difficultyOptions = [
{ id: "easy", label: "EASY" },
{ id: "intermediate", label: "INTERMEDIATE" },
{ id: "hard", label: "HARD" }];


export const questionCountOptions = [5, 10, 15, 20];

export const worksheetFormatOptions = [
  { id: "practice", label: "PRACTICE SHEET" },
  { id: "revision", label: "REVISION WORKSHEET" },
  { id: "homework", label: "HOMEWORK ACTIVITY" },
  { id: "classroom", label: "CLASSROOM EXERCISE" },
];

export const learningObjectivesLabel = "Learning objectives (optional)";
export const learningObjectivesPlaceholder =
  "e.g. Students will explain how photosynthesis converts light energy.";

export const teacherInstructionsLabel = "Teacher instructions (optional)";
export const teacherInstructionsPlaceholder =
  "e.g. Emphasize chloroplasts and keep vocabulary at grade level.";

export const worksheetFormatHeading = "WORKSHEET FORMAT";

export const generateLessonFlowLabel = "Generate Lesson Flow";

export const generateLessonFlowHint =
"Creates a high-quality, structured pedagogical guide for your classroom";

export const defaultWorksheetConfig = {
  selectedTopicId: "",
  selectedTopicLabel: "",
  topicText: "",
  questionTypes: ["mcqs"],
  difficulty: "intermediate",
  questionCount: 10,
  includeAnswerKey: true,
  worksheetFormat: "practice",
  learningObjectives: "",
  teacherInstructions: "",
  pastedContent: "",
};